
import { Options, Vue } from 'vue-class-component';
import AssignCourier from './components/assign-courier/index.vue';
import GeoAddressTreeSelector from "./components/geo-address-tree-selector/index.vue"
import { ManageAreaController } from '@/app/ui/controllers/ManageAreaController';
import DynamicShift from './components/dynamic-shift/index.vue'
import { CreateAreaApiRequest, ListAvailableCourierApiRequest } from "@/data/payload/api/ManageAreaApiRequest";
import CreateAreaContainer from './components/create-area-container.vue';
import { ModalMessageEntities } from '@/domain/entities/MainApp';
import { Confirmable } from '@/decorators/confirmable';
import { MainAppController } from '@/app/ui/controllers/MainAppController';

@Options({
  components: {
    AssignCourier,
    GeoAddressTreeSelector,
    DynamicShift,
    CreateAreaContainer
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      return next();
    }

    if (!this.successCreate) this.onLeavePage(next);
    else next();
  }
})
class ManageAreaCreate extends Vue {
  isShiftEnabled = false;
  selectedCourier: any = "";
  geoAddressValues: number[] = [];
  shifts = new ListAvailableCourierApiRequest();
  isFormValid = false;
  form: CreateAreaApiRequest = new CreateAreaApiRequest();
  successCreate = false;

  @Confirmable(new ModalMessageEntities({
    customParentButton: "w-full",
    customWrapperButton: "w-full",
    customButton: "w-full",
    customWidth: "417px",
    title: "Simpan Area Dedicated?",
    image: "badge-confirmation-general",
    message: "Area dan dedicated kurir yang Anda pilih akan ditambahkan. Pengaturan ini masih dapat diubah",
    textCancel: "Batal",
    textSuccess: "Simpan"
  }))
  confirmSubmit() {
    this.handleSubmit();
  }

  async handleSubmit() {
    if (!this.isFormValid) return;
    try {
      MainAppController.closeMessageModal();
      MainAppController.showLoading();
      await ManageAreaController.createArea(this.form);
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          title: this.$t("pickupDashboard.manageArea.successTitle"),
          message: this.$t("pickupDashboard.manageArea.successMessage"),
          image: "badge-success",
          textSuccess: this.$t("pickupDashboard.manageArea.ok"),
          onSubmit: () => {
            this.successCreate = true;
            this.$router.push("/pickup-dashboard/manage-area");
            MainAppController.closeMessageModal();
          }
        })
      );
    } catch (error) {
      const defaultMessage = this.$t(
        "pickupDashboard.manageArea.createFailedDefaultMessage"
      );
      let message = defaultMessage;

      if (!error?.response) {
        message = this.$t(
          "pickupDashboard.manageArea.createFailedInternetMessage"
        );
      }

      if (error?.response && error?.response?.data?.message?.en.includes('uplicate')) {
        message = error?.response?.data?.message?.id;
      }

      if (error?.response && error?.response?.data?.message?.en.includes('Duplicate area with')) {
        message = defaultMessage;
      }

      MainAppController.showMessageModal(
        new ModalMessageEntities({
          title: this.$t("pickupDashboard.manageArea.createFailedTitle"),
          message,
          image: "circle-error",
          textSuccess: this.$t("pickupDashboard.manageArea.ok"),
          onSubmit: MainAppController.closeMessageModal
        })
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  @Confirmable(
    new ModalMessageEntities({
      customParentButton: "w-full",
      customWrapperButton: "w-full",
      customButton: "w-full",
      customWidth: "417px",
      title: "Yakin keluar halaman?",
      image: "badge-confirmation-general",
      message: "Proses yang sedang berjalan akan dibatalkan dan data akan terhapus.",
      textCancel: "Batal",
      textSuccess: "Ya, Keluar"
    })
  )
  onLeavePage(next: any) {
    next();
  }
}

export default ManageAreaCreate;
